// extracted by mini-css-extract-plugin
module.exports =  {"root":"n2o2fv6ZUEFhpt8pleL4","dimensions":"dZAe03c7rUxABjhWW5ha"};